import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { AuthModule } from '../../../auth/auth.module';
import { SearchModule } from '../../../shared/components/search/search.module';
import { AircraftSearchBarService } from './aircraft-search-bar.service';
import { AircraftSearchBarComponent } from './aircraft-search-bar.component';
import { AircraftSharedModule } from '../../../aircraft/components/shared/aircraft-shared.module';

@NgModule({
    declarations: [
        AircraftSearchBarComponent
    ],
    providers: [
        AircraftSearchBarService
    ],
    imports: [
        AuthModule,
        CommonModule,
        SearchModule,
        FormsModule.withConfig({callSetDisabledState: 'whenDisabledForLegacyCode'}),
        AircraftSharedModule
    ],
    exports: [
        AircraftSearchBarComponent
    ]
})
export class AircraftSearchBarModule {
}
